/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Export format enumeration
 */
export enum HftExportFormat {

    Csv = 'csv',

    Json = 'json',

    Prometheus = 'prometheus'
}
